import { useState } from "react";
import {
  RiAddLine,
  RiArrowLeftLine,
  RiMoneyDollarCircleLine,
  RiLinkM,
  RiMailLine,
  RiWhatsappLine,
  RiTimeLine,
  RiCheckLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const PaymentCollection = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([
    {
      id: 1,
      invoiceNumber: "INV-2024-001",
      customerName: "Tech Corp Ltd",
      amount: 2499.99,
      dueDate: "2024-03-15",
      status: "Pending",
      paymentLink: "https://pay.example.com/inv-2024-001",
    },
    {
      id: 2,
      invoiceNumber: "INV-2024-002",
      customerName: "Design Agency Inc",
      amount: 1899.99,
      dueDate: "2024-03-10",
      status: "Partially Paid",
      paymentLink: "https://pay.example.com/inv-2024-002",
    },
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Paid":
        return "bg-green-100 text-green-800";
      case "Pending":
        return "bg-yellow-100 text-yellow-800";
      case "Partially Paid":
        return "bg-blue-100 text-blue-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="max-w-full mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/billing")}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
          >
            <RiArrowLeftLine className="w-5 h-5" />
          </button>
          <h1 className="text-3xl font-bold text-gray-900">
            Payment Collection
          </h1>
        </div>
        <button className="btn btn-primary flex items-center gap-2">
          <RiAddLine className="w-5 h-5" />
          New Payment Link
        </button>
      </div>

      {/* Payment Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="card bg-primary-50">
          <div className="flex items-center gap-4">
            <RiMoneyDollarCircleLine className="w-10 h-10 text-primary-600" />
            <div>
              <h3 className="text-lg font-semibold text-primary-900">
                Total Collected
              </h3>
              <p className="text-2xl font-bold text-primary-700">$12,499.99</p>
            </div>
          </div>
        </div>
        <div className="card bg-yellow-50">
          <div className="flex items-center gap-4">
            <RiTimeLine className="w-10 h-10 text-yellow-600" />
            <div>
              <h3 className="text-lg font-semibold text-yellow-900">
                Pending Payments
              </h3>
              <p className="text-2xl font-bold text-yellow-700">$4,399.98</p>
            </div>
          </div>
        </div>
        <div className="card bg-green-50">
          <div className="flex items-center gap-4">
            <RiCheckLine className="w-10 h-10 text-green-600" />
            <div>
              <h3 className="text-lg font-semibold text-green-900">
                Success Rate
              </h3>
              <p className="text-2xl font-bold text-green-700">85%</p>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Links Table */}
      <div className="card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-4 px-4">Invoice</th>
                <th className="text-left py-4 px-4">Customer</th>
                <th className="text-left py-4 px-4">Amount</th>
                <th className="text-left py-4 px-4">Due Date</th>
                <th className="text-left py-4 px-4">Status</th>
                <th className="text-right py-4 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.id} className="border-b">
                  <td className="py-4 px-4">{payment.invoiceNumber}</td>
                  <td className="py-4 px-4">{payment.customerName}</td>
                  <td className="py-4 px-4">${payment.amount}</td>
                  <td className="py-4 px-4">
                    {new Date(payment.dueDate).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        payment.status,
                      )}`}
                    >
                      {payment.status}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex justify-end gap-2">
                      <button
                        title="Copy Payment Link"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiLinkM className="w-5 h-5" />
                      </button>
                      <button
                        title="Send Email"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiMailLine className="w-5 h-5" />
                      </button>
                      <button
                        title="Send WhatsApp"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiWhatsappLine className="w-5 h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentCollection;
